module.exports = __webpack_public_path__ + "static/assets/d6f130fb79e78e4dd351fd930e742bcc.png";